/**
 * Generador de idempotency_key estable por sesión de formulario.
 * - Genera un uuid al montar el hook.
 * - Se puede "resetear" (por ejemplo, después de un envío exitoso o al abrir un modal nuevo).
 * - El mismo key se reutiliza para reintentos por error de red del MISMO envío lógico
 *   (el usuario aprieta "Enviar" y hay un timeout → el reintento manual usa el mismo key).
 */
import { useCallback, useEffect, useState } from 'react';

function generateKey() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `k-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

export function useIdempotencyKey(active = true) {
  const [key, setKey] = useState(() => generateKey());

  useEffect(() => {
    // Al activarse (por ejemplo al abrir un modal) generamos uno nuevo
    if (active) setKey(generateKey());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  const reset = useCallback(() => setKey(generateKey()), []);
  return { key, reset };
}
